import makeStyles from '@mui/styles/makeStyles'

export default makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'space-around',
    width: '100%',
    minHeight: '100px',

    '& .MuiFormLabel-asterisk': {
      color: theme.colors.red01
    },

    '& fieldset': {
      margin: 0
    }
  },

  companyFormLabel: {
    color: theme.palette.grey[800],
    marginBottom: theme.spacing(2),

    '& > span': {
      color: '#cc0000'
    }
  },

  companyFormControl: {
    flex: '1 1 auto',
    width: '100%',
    marginBottom: theme.spacing(8)
  },

  formActionsWrapper: {
    width: '100%',
    marginTop: theme.spacing(4)
  },

  formActions: {
    display: 'flex',
    justifyContent: 'flex-end',

    '& button': {
      marginLeft: theme.spacing(1)
    }
  },

  formError: {
    marginBottom: theme.spacing(1)
  },

  search: {
    marginLeft: theme.spacing(2)
  },

  loader: {
    padding: theme.spacing(2)
  }
}))

export const useStylesForCompanyLabel = makeStyles(theme => ({
  root: {
    color: theme.palette.primary.main
  }
}))
